import React from 'react';
import PropTypes from 'prop-types';
import { ClippedContainer } from 'site-modules/shared/components/clipped-container/clipped-container';

const DESKTOP_MASK = {
  name: 'curve-footer-mask',
  path: 'M1,0.689 C1,0.689,1,0.689,1,0.689 V1 H0 L0,0.057 C0.227,0.114,0.486,0.116,0.756,0.067 C0.839,0.049,0.921,0.027,1,0 V0.689',
};

const MOBILE_MASK = {
  name: 'curve-footer-mask',
  path: 'M0,1 H1 V0 C0.984,0.002,0.969,0.004,0.953,0.005 C0.626,0.036,0.304,0.054,0,0.059 L0,1',
};

export function CurveOverFooter({ isMobile = false }) {
  return (
    <ClippedContainer
      mask={isMobile ? MOBILE_MASK : DESKTOP_MASK}
      containerClasses="curve-over-footer w-100 pos-a left-0"
    />
  );
}

CurveOverFooter.propTypes = {
  isMobile: PropTypes.bool,
};
